import { render, staticRenderFns } from "./host-search.vue?vue&type=template&id=20df5af3&scoped=true&"
import script from "./host-search.vue?vue&type=script&lang=js&"
export * from "./host-search.vue?vue&type=script&lang=js&"
import style0 from "./host-search.vue?vue&type=style&index=0&id=20df5af3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20df5af3",
  null
  
)

export default component.exports